import { Drive } from "../../../common/types/drive";
import { DBDriveStatus } from "../../molecules/DBDriveStatus";
import * as S from "./DBDriveSection.style";

interface DBDriveSectionProps {
  drive: Drive;
  isLoading: boolean;
}
export const DBDriveSection = ({ drive, isLoading }: DBDriveSectionProps) => {
  return (
    <S.DBDriveSection>
      <DBDriveStatus type="hdd" drive={drive} isLoading={isLoading} />
    </S.DBDriveSection>
  );
};
